export default Object.freeze({
    CHOFER: 'CHOFER',
    BACKOFFICE: 'BACKOFFICE',
})